import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './TermsOfService.css';
import { FormattedMessage } from 'react-intl';

const TermsOfService = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  // prettier-ignore
  return (
    <div className={classes}>
      {/* <p className={css.lastUpdated}>Last updated: October 30, 2017</p> */}
      <ol>
        <li>
          <h2>
            <FormattedMessage id="Terms.head1" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 2 }, (_, index) => index + 1).map((term, index) => {
                if (term === 1) {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p1.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.1'} />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.2'} />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.3'} />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.4'} />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.5'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.6'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p1.' + term + '.7'} />
                      <br />
                      <br />
                    </li>
                  );
                }
                return (
                  <li key={index}>
                    <FormattedMessage id={'Terms.p1.' + term} />
                    <br />
                    <br />
                  </li>
                );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head2" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 4 }, (_, index) => index + 1).map((term, index) => {
                return (
                  <li key={index}>
                    <FormattedMessage id={'Terms.p2.' + term} />
                    <br />
                    <br />
                  </li>
                );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head3" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 2 }, (_, index) => index + 1).map((term, index) => {
                if (term === 1) {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p3.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.1'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.2'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.3'} />
                      <br />
                      <br />
                    </li>
                  );
                }
                if (term === 2){
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p3.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.1'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.2'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.3'} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p3.' + term + '.4'} />
                      <br />
                      <br />
                    </li>
                  );  
                }
                
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head4" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 4 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p4.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head5" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 3 }, (_, index) => index + 1).map((term, index) => {
                if(term === 1){
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p5.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".1"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".2"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".3"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".4"} />
                      <br />
                      <br />
                    </li>
                  );
                }
                if(term === 2){
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p5.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".1"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + ".2"} />
                      <br />
                      <br />
                    </li>
                  );
                }
                if(term === 3){
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p5.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + '.1'} />
                      <ul>
                        <li>
                          <FormattedMessage id={'Terms.p5.' + term + '.1.1'} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p5.' + term + '.1.2'} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p5.' + term + '.1.3'} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p5.' + term + '.1.4'} />
                        </li>
                        <FormattedMessage id={'Terms.p5.' + term + '.1.5'} />
                      </ul>
                      <br />
                      <FormattedMessage id={'Terms.p5.' + term + '.2'} />
                      <br />
                      <br />
                    </li>
                  );
                }
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head6" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 6 }, (_, index) => index + 1).map((term, index) => {
                  if(term === 3){
                    return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p6.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".1"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".2"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".3"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".4"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".5"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p6.' + term + ".6"} />
                      <br />
                      <br />
                    </li>
                  );
                  }
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p6.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head7" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 8 }, (_, index) => index + 1).map((term, index) => {
                if(term === 3){
                  return(
                    <li key={index}>
                      <FormattedMessage id={'Terms.p7.' + term} />
                      <ul>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".1"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".2"} />
                        </li>
                      </ul>
                      <br />
                      <FormattedMessage id={'Terms.p7.' + term + ".3"} />
                      <br />
                      <br />
                    </li>
                  )
                }

                if(term === 5){
                  return(
                    <li key={index}>
                      <FormattedMessage id={'Terms.p7.' + term} />
                      <ul>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".1"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".2"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".3"} />
                        </li>
                      </ul>
                      <br />
                    </li>
                  )
                }
                if(term === 6){
                  return(
                    <li key={index}>
                      <FormattedMessage id={'Terms.p7.' + term} />
                      <ul>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".1"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".2"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".3"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".4"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".5"} />
                        </li>
                        <li>
                          <FormattedMessage id={'Terms.p7.' + term + ".6"} />
                        </li>
                      </ul>
                      <br />
                    </li>
                  )
                }

                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p7.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head8" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 4 }, (_, index) => index + 1).map((term, index) => {
                  if( term === 1){
                    return (
                      <li key={index}>
                        <FormattedMessage id={'Terms.p8.' + term} />
                        <br />
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.1'} />
                        <br />
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.2'} />
                        <ul>
                          <li>
                            <FormattedMessage id={'Terms.p8.' + term + '.2.1'} />
                          </li>
                          <li>
                            <FormattedMessage id={'Terms.p8.' + term + '.2.2'} />
                          </li>
                          <li>
                            <FormattedMessage id={'Terms.p8.' + term + '.2.3'} />
                            <li>
                            <FormattedMessage id={'Terms.p8.' + term + '.2.4'} />
                          </li>
                          </li>
                          
                        </ul>
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.3'} />
                        <br />
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.4'} />
                        <br />
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.5'} />
                        <br />
                        <br />
                        <FormattedMessage id={'Terms.p8.' + term + '.6'} />
                        <br />
                        <br />
                      </li>
                    );
                  }
                  if( term === 2){
                    return(
                      <li key={index}>
                      <FormattedMessage id={'Terms.p8.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p8.' + term + ".1"} />
                      <br />
                      <br />
                    </li>
                    )
                  }
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p8.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head9" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 1 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p9.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head10" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 5 }, (_, index) => index + 1).map((term, index) => {
                if( term === 1){
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p10.' + term} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p10.' + term + ".1"} />
                      <br />
                      <br />
                      <FormattedMessage id={'Terms.p10.' + term + ".2"} />
                      <br />
                      <br />
                    </li>
                  )
                }
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p10.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head11" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 1 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p11.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head12" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 3 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p12.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head13" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 1 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p13.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head14" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 3 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p14.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="Terms.head15" />
          </h2>
          <p>
            <ul>
              {Array.from({ length: 2 }, (_, index) => index + 1).map((term, index) => {
                  return (
                    <li key={index}>
                      <FormattedMessage id={'Terms.p15.' + term} />
                      <br />
                      <br />
                    </li>
                  );
              })}
            </ul>
          </p>
        </li>
      </ol>
    </div>
  );
};

TermsOfService.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

TermsOfService.propTypes = {
  rootClassName: string,
  className: string,
};

export default TermsOfService;
